// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { EshopBusStopZoneControllerFindTariffZoneData } from './EshopBusStopZoneControllerFindTariffZoneData.gen';
import type { EshopBusStopZoneControllerFindTariffZoneErrors } from './EshopBusStopZoneControllerFindTariffZoneErrors.gen';
import type { EshopBusStopZoneControllerFindTariffZoneResponses } from './EshopBusStopZoneControllerFindTariffZoneResponses.gen';
import type { EshopBusStopZoneControllerGetAllData } from './EshopBusStopZoneControllerGetAllData.gen';
import type { EshopBusStopZoneControllerGetAllErrors } from './EshopBusStopZoneControllerGetAllErrors.gen';
import type { EshopBusStopZoneControllerGetAllResponses } from './EshopBusStopZoneControllerGetAllResponses.gen';
import type { EshopBusStopZoneControllerGetMhdBusStopZoneData } from './EshopBusStopZoneControllerGetMhdBusStopZoneData.gen';
import type { EshopBusStopZoneControllerGetMhdBusStopZoneErrors } from './EshopBusStopZoneControllerGetMhdBusStopZoneErrors.gen';
import type { EshopBusStopZoneControllerGetMhdBusStopZoneResponses } from './EshopBusStopZoneControllerGetMhdBusStopZoneResponses.gen';
import type { EshopBusStopZoneControllerGetMhdZoneTariffZoneData } from './EshopBusStopZoneControllerGetMhdZoneTariffZoneData.gen';
import type { EshopBusStopZoneControllerGetMhdZoneTariffZoneErrors } from './EshopBusStopZoneControllerGetMhdZoneTariffZoneErrors.gen';
import type { EshopBusStopZoneControllerGetMhdZoneTariffZoneResponses } from './EshopBusStopZoneControllerGetMhdZoneTariffZoneResponses.gen';
import type { EshopBusStopZoneControllerGetOneData } from './EshopBusStopZoneControllerGetOneData.gen';
import type { EshopBusStopZoneControllerGetOneErrors } from './EshopBusStopZoneControllerGetOneErrors.gen';
import type { EshopBusStopZoneControllerGetOneResponses } from './EshopBusStopZoneControllerGetOneResponses.gen';
import type { Options } from './Options.gen';

export class EshopBusStopZoneController {
    /**
     * Get bus stop zones.
     */
    public static getAll<ThrowOnError extends boolean = false>(options?: Options<EshopBusStopZoneControllerGetAllData, ThrowOnError>) {
        return (options?.client ?? client).get<EshopBusStopZoneControllerGetAllResponses, EshopBusStopZoneControllerGetAllErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/bus-stop-zones',
            ...options
        });
    }
    
    /**
     * Check if bus stop zone combination is valid, if so, return ticket type and note
     */
    public static findTariffZone<ThrowOnError extends boolean = false>(options: Options<EshopBusStopZoneControllerFindTariffZoneData, ThrowOnError>) {
        return (options.client ?? client).get<EshopBusStopZoneControllerFindTariffZoneResponses, EshopBusStopZoneControllerFindTariffZoneErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/bus-stop-zones/find-tariff-zone',
            ...options
        });
    }
    
    /**
     * Get mhd zone tariff zone.
     */
    public static getMhdZoneTariffZone<ThrowOnError extends boolean = false>(options?: Options<EshopBusStopZoneControllerGetMhdZoneTariffZoneData, ThrowOnError>) {
        return (options?.client ?? client).get<EshopBusStopZoneControllerGetMhdZoneTariffZoneResponses, EshopBusStopZoneControllerGetMhdZoneTariffZoneErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/bus-stop-zones/mhd-zone-tariff-zone',
            ...options
        });
    }
    
    /**
     * Get mhd bus stop zone.
     */
    public static getMhdBusStopZone<ThrowOnError extends boolean = false>(options?: Options<EshopBusStopZoneControllerGetMhdBusStopZoneData, ThrowOnError>) {
        return (options?.client ?? client).get<EshopBusStopZoneControllerGetMhdBusStopZoneResponses, EshopBusStopZoneControllerGetMhdBusStopZoneErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/bus-stop-zones/mhd-bus-stop-zone',
            ...options
        });
    }
    
    /**
     * Get bus stop zone detail.
     */
    public static getOne<ThrowOnError extends boolean = false>(options: Options<EshopBusStopZoneControllerGetOneData, ThrowOnError>) {
        return (options.client ?? client).get<EshopBusStopZoneControllerGetOneResponses, EshopBusStopZoneControllerGetOneErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/bus-stop-zones/{id}',
            ...options
        });
    }
}
